import "./Dumbbell3D.css";

// Luz fija arriba y delante. CSS no ilumina, así que cada cara lleva su tono
// calculado: cuanto más mira a la luz, más clara.
const LUZ = { y: -0.55, z: 0.84 };

// Piezas de media mancuerna, del centro hacia fuera; la otra mitad es simétrica.
// x: centro en el eje de la barra, largo: grosor, tapas: qué caras planas se ven.
const MITAD = [
  { x: 76, largo: 40, radio: 56, caras: 40, tipo: "disco", tapas: ["in", "out"] },
  { x: 104, largo: 16, radio: 44, caras: 32, tipo: "disco", tapas: ["out"] },
  { x: 117, largo: 10, radio: 13, caras: 12, tipo: "tope", tapas: ["out"] },
  { x: 130, largo: 16, radio: 7, caras: 10, tipo: "barra", tapas: ["out"] }
];
const PIEZAS = [
  { x: 0, largo: 112, radio: 7, caras: 12, tipo: "barra", tapas: [] },
  ...MITAD,
  ...MITAD.map((p) => ({ ...p, x: -p.x })) // el signo de x ya orienta las tapas
];

const TONOS = {
  disco: (l) => `hsl(150 62% ${7 + l * 30}%)`,
  tope: (l) => `hsl(150 6% ${22 + l * 46}%)`,
  barra: (l) => `hsl(150 5% ${28 + l * 60}%)`
};

function caras({ x, largo, radio, caras: k, tipo, tapas }, clave) {
  const alto = 2 * radio * Math.tan(Math.PI / k) + 0.6; // +0.6 tapa las juntas
  const lados = Array.from({ length: k }, (_, i) => {
    const a = (i * 360) / k;
    const rad = (a * Math.PI) / 180;
    // normal de la cara tras rotateX(a): (0, -sin a, cos a)
    const luz = Math.max(0, -Math.sin(rad) * LUZ.y + Math.cos(rad) * LUZ.z);
    return (
      <span
        key={`${clave}-l${i}`}
        className="db-cara"
        style={{
          width: largo,
          height: alto,
          marginLeft: -largo / 2,
          marginTop: -alto / 2,
          background: TONOS[tipo](0.25 + luz * 0.75),
          transform: `translateX(${x}px) rotateX(${a}deg) translateZ(${radio}px)`
        }}
      />
    );
  });

  const planas = tapas.map((lado) => {
    const signo = (lado === "out") === x >= 0 ? 1 : -1;
    return (
      <span
        key={`${clave}-t${lado}`}
        className={`db-cara db-tapa db-tapa-${tipo}`}
        style={{
          width: radio * 2,
          height: radio * 2,
          marginLeft: -radio,
          marginTop: -radio,
          transform: `translateX(${x + (signo * largo) / 2}px) rotateY(${signo * 90}deg)`
        }}
      />
    );
  });

  return [...lados, ...planas];
}

const GEOMETRIA = PIEZAS.flatMap((p, i) => caras(p, i));

function Dumbbell3D({ className = "" }) {
  return (
    <div className={`db-escena ${className}`} aria-hidden="true">
      <div className="db-cursor">
        <div className="db-giro">{GEOMETRIA}</div>
      </div>
      <div className="db-sombra" />
    </div>
  );
}

export default Dumbbell3D;
